import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import {
  requestCommitmentItems,
  requestCommitmentStatuses,
} from '../features/partner360/commitment'
import {
  selectFinancialYear,
  selectPartnerId,
  selectProgramType,
} from '../features/partner360/configuration'

import { useAppDispatch } from './useAppDispatch'
import { useJBPCommitmentData } from './useJBPCommitmentData'

export const useSignature = () => {
  /** -------------------- Variables ----------------------- */
  const [signatureId, setSignatureId] = useState<number>()

  const dispatch = useAppDispatch()
  const partnerId = useSelector(selectPartnerId)
  const programType = useSelector(selectProgramType)
  const fYear = useSelector(selectFinancialYear)
  const ownerId = useSelector(selectAppOwnerId)

  const { data } = useJBPCommitmentData()

  /** -------------------- Methods ----------------------- */
  const dropSignature = useCallback(
    async (widgetName: string) => {
      const url = proxy('/webservice/621/sp/v3/spJBPCommitmentDrop/call')

      const [accessToken] = getTokens(ownerId)
      const headers = new HttpHeaders()
      if (accessToken) {
        headers.add('Authorization', `Bearer ${accessToken}`)
      }

      const payload = {
        'p.PartnerId': partnerId,
        'p.FYear': fYear,
        'p.ProgramType': programType,
        'p.Comment': `Data was changed in the ${widgetName} widget`,
      }

      const response = await Rest.post({ url, payload, headers })
      if (response && response.Rows) {
        setSignatureId(undefined)
        await dispatch(
          requestCommitmentItems({
            partnerId,
            programType,
            fYear,
          })
        )

        await dispatch(
          requestCommitmentStatuses({
            partnerId,
            fYear,
          })
        )
      }
    },
    [dispatch, ownerId, partnerId, fYear, programType]
  )

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    const matchedCommitment = data.find((it) => it.IsAcknowledged === 1)
    if (matchedCommitment) {
      setSignatureId(matchedCommitment.EntryId)
    } else {
      setSignatureId(undefined)
    }
  }, [data])

  return {
    signatureId,
    dropSignature,
  }
}
